import React, { useState } from "react";
import { SharedAccountManagePage, SharedAccountWelcomePage } from "../../../shared-account";

interface Props {
	onComplete: () => void;
}

export const Step6SharedAccount: React.FC<Props> = ({ onComplete }) => {
	const [phase, setPhase] = useState<"welcome" | "manage">("welcome");

	if (phase === "welcome") {
		return <SharedAccountWelcomePage onSkip={onComplete} onSetUp={() => setPhase("manage")} />;
	}

	return <SharedAccountManagePage onSkip={onComplete} onComplete={onComplete} />;
};
